import * as CHAIN_1 from "./1";
import * as CHAIN_42161 from "./42161";
import * as CHAIN_200810 from "./200810";
import * as CHAIN_200901 from "./200901";

export const chains = {
	1: CHAIN_1,
	42161: CHAIN_42161,
	200810: CHAIN_200810,
	200901: CHAIN_200901,
};
